<template>
  <div class="root">
    <div class="gage" :class="{ 'is-text-border': isTextBorder }" ref="gage">
      <p class="gage__text">みんなの応援ゲージ</p>
      <p class="gage__current">
        <span class="gage__current__text">現在</span>
        <span class="gage__current__value">{{ countUpValue }}</span>
        <span class="gage__current__text">%</span>
      </p>
      <div class="bar" :style="{ transform: `translateX(${barValue}%)` }"></div>
      <div class="bar-mask" :style="{ width: `${barMaskValue}%` }"></div>
    </div>
    <img class="chara1" src="../assets/images/chara1.png" />
    <img class="chara2" src="../assets/images/chara2.png" />
  </div>
</template>

<style lang="scss" scoped>
.root {
  position: relative;
  width: 100%;
}
.gage {
  position: relative;
  width: 545px;
  height: 260px;
  margin: 0 auto;
  border: solid 10px #6F7071;
  border-radius: 60px;
  overflow: hidden;
  background-color: #fff;
  box-shadow: $shadow;
  &__text {
    position: absolute;
    top: 6%;
    left: 50%;
    z-index: 1;
    transform: translateX(-50%);
    width: 100%;
    font-size: 4rem;
  }
  &__current {
    display: flex;
    align-items: flex-end;
    position: absolute;
    bottom: 20%;
    left: 50%;
    z-index: 1;
    transform: translateX(-50%);
    width: 80%;
    height: 110px;
    line-height: 1;
    &__text {
      width: 80px;
      font-size: 3.8rem;
      &:first-of-type {
        text-align: left;
      }
      &:last-of-type {
        text-align: right;
      }
    }
    &__value {
      flex: 1;
      font-family: $normal-font;
      font-size: 12rem;
      line-height: 0.7;
      font-weight: 500;
    }
  }

  &.is-text-border {
    .gage {
      &__text,
      &__current__text {
        $size: 3px;
        $blur: 3px;
        $color: #fff;
        text-shadow:
          $size $size $blur $color,
          -1 * $size $size $blur $color,
          $size -1 * $size $blur $color,
          -1 * $size -1 * $size $blur $color;
      }
      &__current__value {
        $size: 4px;
        $blur: 6px;
        $color: #fff;
        text-shadow:
          $size $size $blur $color,
          -1 * $size $size $blur $color,
          $size -1 * $size $blur $color,
          -1 * $size -1 * $size $blur $color;
      }
    }
  }

  @include media-sp() {
    width: 100%;
    height: 150px;
    margin: 0 auto;
    border-width: 7px;
    border-radius: 50px;
    &__text {
      font-size: 2.3rem;
    }
    &__current {
      &__text {
        font-size: 2.4rem;
      }
      &__value {
        font-size: 6rem;
      }
    }

    &.is-text-border {
      .gage {
        &__text,
        &__current__text {
          $size: 2px;
          $blur: 2px;
          $color: #fff;
          text-shadow:
            $size $size $blur $color,
            -1 * $size $size $blur $color,
            $size -1 * $size $blur $color,
            -1 * $size -1 * $size $blur $color;
        }
        &__current__value {
          $size: 3px;
          $blur: 4px;
          $color: #fff;
          text-shadow:
            $size $size $blur $color,
            -1 * $size $size $blur $color,
            $size -1 * $size $blur $color,
            -1 * $size -1 * $size $blur $color;
        }
      }
    }
  }
}
.bar {
  width: 1000%;
  height: 100%;
  background: linear-gradient(
    135deg,
    #FDF1F0,
    #D8F2FF,
    #FCCBC8,
    #D6E7F3,
    #FAACA8,
    #EAC887,
    #FAACA8,
    #F86B2D,
    #F8DA49,
    #F83600
  );
}
.bar-mask {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  background-color: #fff;
}
.chara1 {
  top: 0;
  margin-left: -500px;
  @include media-sp() {
    margin-left: -57px;
  }
}
.chara2 {
  top: 0;
  margin-left: 232px;
  @include media-sp() {
    margin-left: 57px;
  }
}
.chara1, .chara2 {
  top: 45%;
  position: absolute;
  transform: translateY(-50%);

  @include media-sp() {
    top: 84%;
    left: 50%;
    transform: translate(-50%, 0);
    width: 100px;
  }
}
</style>

<script>
import gsap, { Power3 } from 'gsap'

export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      countUpValue: 0,
      barValue: 0,
      barMaskValue: 100
    }
  },
  mounted() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.animationStart()
          observer.disconnect()
        }
      })
    })
    observer.observe(this.$refs.gage)
  },
  computed: {
    isTextBorder() {
      return this.value >= 70
    }
  },
  methods: {
    animationStart() {
      const duration = 12 * (this.value / 100)
      const value = { count: this.countUpValue }
      gsap.fromTo(
        value,
        {},
        {
          count: this.value,
          ease: Power3.easeOut,
          delay: 1,
          duration, // seconds
          onUpdate: () => {
            this.barValue = 90 * (value.count / 100) * -1
            this.barMaskValue = 100 - value.count
            const count = Math.round(value.count)
            if (this.countUpValue !== count) {
              this.countUpValue = count
            }
          }
        }
      )
    }
  }
}

</script>
